import { Anchor, NonIdealState } from "@itwin/itwinui-react"
import styles from "./DeprecationNotice.module.css"
import { SvgError } from "@itwin/itwinui-illustrations-react"

export const DeprecationNotice = () => {
  return (
    <div className={styles.notice}>
      <NonIdealState
        svg={<SvgError />}
        heading="Deprecated"
        description={<>This sandbox uses an older version of <Anchor href="https://www.itwinjs.org/">iTwin.js</Anchor> that was deprecated</>}
      />
    </div>
  )
}